// extracted by mini-css-extract-plugin
export default {"mobile_filter_character_set":"CharacterSetMobileScreen_mobile_filter_character_set__yNIVV"};